import { withInstall } from '@hd-front-end/utils'
import CollapseTransition from './src/collapse-transition.vue'

import type { SFCWithInstall } from '@hd-front-end/utils'

export const ElCollapseTransition: SFCWithInstall<typeof CollapseTransition> =
  withInstall(CollapseTransition)

export default ElCollapseTransition
